import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const fetchConsentLogs = createAsyncThunk(
  "consentLogs/fetch",
  async ({ token, ...queryParams }) => {
    const response = await api.get("/consent", {
      token,
      params: queryParams,
    });
    return response.data;
  }
);